module.exports = __webpack_public_path__ + "media/images/proof_links/amazon-8aaa876eda048234c83f32c865d2a1f3.svg";